<template>
  <Block class="activity-time" title="活动主题">
    <div class="block-content">
      <div class="activity-desc">
        在快手发布30秒以上的作品并带{{ topics?.length }}个话题：<template v-for="(topic, i) in topics"><span class="topic">{{ topic
            }}</span>{{ i < topics.length - 1 ? "、" : "" }} </template>，发布后复制作品链接，在下方选择对应的专题并完成投稿。
      </div>
      <div class="activity-item">
        <div class="activity-item-header">
          <div class="activity-item__title">01. 专业评审奖通道</div>
          <Button v-if="isStaging2 !== true" class="item-btn" size="large" type="simple"
            @click="handleContribute('expertReview')">
          </Button>
        </div>
        <div v-if="isLargeScreen === false" class="img-mobile">
          <VueLazyImg style="width: 2.18rem"
            src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/d5618c65-c8bf-42a6-bd5b-7d6d90c75003.png" />
          <VueLazyImg style="width: 2.18rem"
            src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/26575fea-7a32-45c9-ba4a-638a94d59e8b.png" />
          <VueLazyImg style="width: 2.18rem"
            src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/d2cdb26b-9a1e-4f77-998f-8d7ba8dee757.png" />
        </div>
        <VueLazyImg v-else classStyle="img"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/182a88a2-704a-48f5-bb76-371a203dc391.png" />
        <div class="tips">
          大赛评委将综合考量以下因素进行作品评选：创意水平、技术水平、主题与表现力、作品影响力。
        </div>
      </div>
      <div class="activity-item">
        <div class="activity-item-header">
          <div class="activity-item__title">02. 快手人气奖通道</div>
          <Button v-if="isStaging2 !== true" class="item-btn" size="large" type="simple"
            @click="handleContribute('kuaishouPopularity')">
          </Button>
        </div>
        <div v-if="isLargeScreen === false" class="img-mobile-2">
          <span class="text">主题不限 创意主场 让想象力动起来！</span>
        </div>
        <VueLazyImg v-else classStyle="img"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/b0cfa054-f8a3-42c8-a384-582feea085f9.png" />
        <div class="tips">
          平台将综合考量投稿作品的快手互动量：观看、点赞、评论、分享。
          <br />
          <br />
          <div class="hint">
            注：禁止以作弊等违规手段影响活动统计数据，最终统计结果以快影平台统计数据为准。如发现任何异常或涉嫌违规的数据，平台有权不计入该等数据，并保留追究相关违规用户法律责任的权利。
          </div>
        </div>
      </div>
    </div>
  </Block>
</template>

<script setup lang="ts">
import { checkAuth } from "./checkPermission";
import Block from "./common/block.vue";
import Button from "./common/button.vue";
import FormModal from "./formModal/formModal.vue";
import { ApiModal } from "~/composables/apiModal";

withDefaults(
  defineProps<{
    topics: string[];
    isStaging2?: boolean;
  }>(),
  { topics: () => [] },
);

const formModal = ref<ApiModal<typeof FormModal>>();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};

onMounted(() => {
  formModal.value = new ApiModal(FormModal);
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

const handleContribute = async (
  type: "expertReview" | "kuaishouPopularity",
) => {
  await checkAuth();
  formModal.value?.show({ actives: [type, 0] });
};
</script>

<style scoped lang="less">
.activity-time {
  margin-bottom: 2.8rem;

  @media screen and(max-width: 1360px) {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.block-content {
  width: 100%;

  @media screen and(max-width: 1360px) {
    width: 100%;
    margin-top: 0.4rem;
    margin-bottom: 0.56rem;
  }
}

.activity-desc {
  font-weight: 300;
  font-size: 0.4rem;
  line-height: 0.6rem;
  margin: 0.8rem 0 1.6rem;
  max-width: 22.36rem;
  color: rgba(255, 255, 255, 0.5);
  font-family: 'Alibaba Puhuiti';

  @media screen and(max-width: 1360px) {
    font-size: 0.24rem;
    line-height: 0.4rem;
    font-weight: 400;
    margin: 0;
    font-family: 'Alibaba Puhuiti';
  }

  .topic {
    color: #4ca9ff;
  }
}

.activity-item {
  width: 22.36rem;
  position: relative;
  padding: 0.6rem 0;

  @media screen and (max-width: 1360px) {
    width: 100%;
    padding: 0.48rem 0 0;
  }

  .item-btn {
    @media screen and (max-width: 1360px) {
      padding: 0 0.2rem;
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    opacity: 0.4;
    background: linear-gradient(97.03deg,
        #ffffff 20.89%,
        #b5ffdf 62.65%,
        #9cedff 83.53%,
        #97b4ff 104.41%);

    @media screen and (max-width: 1360px) {
      display: none;
    }
  }

  &__title {
    font-size: 0.6rem;
    font-weight: 400;
    line-height: 0.8rem;
    color: #fff;

    @media screen and (max-width: 1360px) {
      font-weight: 600;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
  }

  .front {
    display: inline-flex;
    width: 0.44rem;

    @media screen and (max-width: 1360px) {
      width: 0.12rem;
    }
  }

  .icon {
    display: inline-flex;
    width: 0.64rem;
    height: 0.64rem;
    background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/35998c57-08d3-4be7-8356-a925ea2eb1a1.png);
    background-size: 100% 100%;
    margin-left: 0.16rem;

    @media screen and (max-width: 1360px) {
      width: 0.4rem;
      height: 0.4rem;
      margin-left: 0;
      background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/417c61e7-12a9-4a92-845f-315c455300ea.png);
    }
  }

  .img {
    width: 100%;
    margin: 0.6rem 0 0.44rem;

    @media screen and (max-width: 1360px) {
      margin: 0.4rem 0 0.24rem;
    }

    &-mobile {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 2.18rem;
      }

      @media screen and (max-width: 1360px) {
        justify-content: center;
        gap: 0.15rem;
        margin: 0.4rem 0 0.24rem;
      }
    }

    &-mobile-2 {
      width: 100%;
      height: 1.76rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: 100% 100%;
      background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/0e06958c-6d9f-4039-b9e7-2ab5a95e0f3d.png);
      background-color: rgba(17, 18, 23, 1);
      border-radius: 0.08rem;
      margin: 0.4rem 0 0.24rem;

      .text {
        font-size: 0.32rem;
        font-weight: 400;
        line-height: 0.44rem;
        color: transparent;
        background: linear-gradient(97.03deg,
            #ffffff 20.89%,
            #b5ffdf 62.65%,
            #9cedff 83.53%,
            #97b4ff 104.41%);
        background-clip: text;
      }
    }
  }

  .tips {
    margin-top: 0.1rem;
    padding: 0.56rem;
    font-size: 0.4rem;
    font-weight: 300;
    line-height: 0.56rem;
    color: rgba(255, 255, 255, 0.7);
    border-radius: 0.16rem;
    background-color: rgba(255, 255, 255, 0.04);

    @media screen and (max-width: 1360px) {
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.4rem;
      padding: 0;
      color: rgba(255, 255, 255, 0.5);
      background-color: rgba(255, 255, 255, 0);
    }

    .hint {
      font-size: 0.4rem;
      line-height: 0.64rem;
      color: rgba(255, 255, 255, 0.3);

      @media screen and (max-width: 1360px) {
        font-size: 0.24rem;
        line-height: 0.36rem;
        font-weight: 400;
      }
    }
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;

    @media screen and (max-width: 1360px) {
      margin-bottom: 0rem;
    }
  }

  &-content {
    display: flex;
    align-items: center;
  }
}

.card {
  display: flex;
  width: 100%;
  justify-content: space-around;
  margin-top: 0.74rem;

  @media screen and(max-width: 1360px) {
    margin-top: 0.24rem;
  }
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and(max-width: 1360px) {
    border-radius: 0.08rem;
    width: 2rem;
    height: 1.36rem;
  }
}
</style>
